module.exports = __webpack_public_path__ + "assets/img/img177.f4a65893.png";